'use client';

import { useOfficeEditingCtx } from '@/app/(app)/settings/office/provider';
import { Select } from '@/components/atoms/select';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { TIMEZONE_OPTIONS } from '@/consts/date-time';

export function OfficeGeneral() {
  const { office, update } = useOfficeEditingCtx();

  return (
    <div className='flex w-full flex-col gap-14'>
      {/* Section: Name, Description, Timezone */}
      <div className='flex flex-col gap-4'>
        <h2 className='text-heading-md'>General</h2>
        <div className='grid gap-2 md:grid-cols-2'>
          <div className='space-y-2'>
            <Label>Name</Label>
            <Input value={office.name} onChange={(e) => update({ name: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Timezone</Label>
            <Select
              options={TIMEZONE_OPTIONS}
              value={office.timezone ?? ''}
              onChange={(value) => update({ timezone: value })}
              className='w-full'
              placeholder='Select office timezone'
            />
          </div>
        </div>
        <div className='space-y-2'>
          <Label>Description</Label>
          <Textarea value={office.description ?? ''} onChange={(e) => update({ description: e.target.value })} />
        </div>
      </div>
      {/* Section: Email, Phone, Website, Google Maps URL */}
      <div className='flex flex-col gap-4'>
        <h2 className='text-heading-md'>Contacts</h2>
        <div className='grid gap-4 gap-x-2 md:grid-cols-2'>
          <div className='space-y-2'>
            <Label>Email</Label>
            <Input value={office.email ?? ''} onChange={(e) => update({ email: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Phone</Label>
            <Input value={office.phone_number ?? ''} onChange={(e) => update({ phone_number: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Website</Label>
            <Input value={office.website ?? ''} onChange={(e) => update({ website: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Google Maps URL</Label>
            <Input value={office.google_maps_url ?? ''} onChange={(e) => update({ google_maps_url: e.target.value })} />
          </div>
        </div>
      </div>
    </div>
  );
}
